
import MapPage from '../pages/map.jsx';
import OnboardingPage from '../pages/onboarding.jsx';
import DiscoverPage from '../pages/discover.jsx';
import AccountPage from '../pages/account.jsx';
import ProfilePage from '../pages/profile.jsx';
import WebsitePage from '../pages/website.jsx';
import DeliveryPage from '../pages/delivery.jsx';
import BranchDashboard from '../pages/branch-dashboard.jsx';
import DeliveryBranchPage from '../pages/branch-delivery.jsx';
import MerchantPage from '../pages/merchant.jsx';
import MerchantProductsPage from '../pages/merchant-products.jsx';
import MerchantWalletPage from '../pages/merchant-wallet.jsx';
import MerchantSalesPage from '../pages/merchant-sales.jsx';
import AdminPage from '../pages/admin.jsx';
import AdminUsersPage from '../pages/admin-users.jsx';
import AdminVendorsPage from '../pages/admin-vendors.jsx';
import AdminWalletsPage from '../pages/admin-wallets.jsx';
import AdminSalesPage from '../pages/admin-sales.jsx';
import SupportPage from '../pages/support.jsx';
import BusinessRegistrationPage from '../pages/business-registration.jsx';
import DeclineApplicationPage from '../pages/decline.jsx';
import StorePage from '../pages/store.jsx';
import CartPage from '../pages/cart.jsx';
import PartnersPage from '../pages/partners.jsx';

import MessageMasterPage from '../pages/message-master.jsx';
import MessageDetailPage from '../pages/message-detail.jsx';

import NotFoundPage from '../pages/404.jsx';

var routes = [
  {
    path: '/',
    component: localStorage.getItem('intro') == 'true' 
      ? localStorage.getItem('onboarding') == 'true' 
        ? OnboardingPage : MapPage
      :  OnboardingPage,
    master: localStorage.getItem('intro') == 'true' 
    ? localStorage.getItem('onboarding') == 'true' 
      ? false : true
    : false,
    options: {
      reloadAll: true,
      transition: "f7-flip"
    },
  },
  {
    path: '/onboarding/',
    component: OnboardingPage
  },  
  {
    path: '/map/',
    component: MapPage,
    master: true,
  },
  {
    path: '/discover/',
    component: DiscoverPage,  
    options:{
      transition: "f7-parallax"
    }
  },
  {
    name: 'account',
    path: '/account/:tab/',
    component: AccountPage,
    master: true,
  },
  {
    path: '/profile/:id/',
    component: ProfilePage,
  },
  {
    path: '/website/:page/',
    component: WebsitePage,
  },
  {
    path: '/branch-dashboard/',
    component: BranchDashboard,
  },
  {
    path: '/branch-delivery/:id/',
    component: DeliveryBranchPage,
  },
  {
    path: '/delivery/',
    component: DeliveryPage,
  },
  {
    name: 'merchant',
    path: '/merchant/',
    component: MerchantPage,    
    tabs: [
      {
        path: '/',
        id: 'merchant-products',
        component: MerchantProductsPage, 
        options:{
          history: true
        }
      },
      {
        path: '/merchant-wallet/',
        id: 'merchant-wallet',
        component: MerchantWalletPage, 
        options:{
          history: true
        }
      },
      {
        path: '/merchant-sales/',
        id: 'merchant-sales',
        component: MerchantSalesPage, 
        options:{
          history: true
        }
      },
    ]
  },
  {
    path: '/partners/',
    component: PartnersPage,
  },
  {
    name: "admin",
    path: '/admin/',
    component: AdminPage,
    tabs: [
      {
        path: '/',
        id: 'all-users',
        component: AdminUsersPage,
      },
      {
        path: '/all-vendors/',
        id: 'all-vendors',
        component: AdminVendorsPage,
      },
      {
        path: '/all-wallets/',
        id: 'all-wallets',
        component: AdminWalletsPage,
      },
      {
        path: '/all-sales/',
        id: 'all-sales',
        component: AdminSalesPage,
      },
    ]
  },  
  {
    path: '/support/',
    component: SupportPage,
  },
  {
    path: '/business-registration/:id/',
    component: BusinessRegistrationPage,
  },
  {
    path: '/decline/:id/',
    component: DeclineApplicationPage,
  },
  {
    name: 'store',
    path: '/store/:merchantID/:productID?/',
    component: StorePage,
  },
  {
    name: 'cart',
    path: '/cart/',
    component: CartPage,
  },  
  {
    name: 'message-master',
    path: '/message-master/:view/:id/:page/',
    component: MessageMasterPage,
    master: true,
  },
  {
    name: 'message-detail',
    path: '/message-detail/:view/:id/:page/',
    component: MessageDetailPage,
  },
  
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
